
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...blogGenericFR]",
      function () {
        return require("private-next-pages/[...blogGenericFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...blogGenericFR]"])
      });
    }
  